<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/lesson-observations', text: 'lessonObservation_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'lessonObservation_listTitle' | translate}}</h1>
        <aside>
            <button *ngIf="canEdit" type="button" class="btn btn-outline-primary" [routerLink]="['/lesson-observations/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-alert level="info" *ngIf="info">
        <div [innerHTML]="info | safeHtml"></div>
    </app-alert>

    <app-table [rows]="items"
               [columns]="columns"
               [page]="page"
               [pageSize]="pageSize"
               [total]="total"
               [auto]="false"
               (pageChange)="onPage($event)"
               (sortChange)="onSort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div class="text-top">
                        {{row.Type}}
                        <span class="hidden-md-up">
                            <app-lesson-observation-status [value]="row.Status"></app-lesson-observation-status>
                        </span>
                    </div>
                    <div>{{row.SubjectName}}</div>
                    <div class="text-sub">{{row.ObserverName}} {{row.ObserverSurname}} &rarr; {{row.TeacherName}} {{row.TeacherSurname}}</div>
                    <div class="hidden-lg-up mt-1">
                        <i class="fi fi-rs-calendar-clock"></i>
                        {{row.Date | appDate}} ({{row.TimeFrom | appTime}} - {{row.TimeTo | appTime}})
                    </div>
                    <div class="hidden-lg-up">
                        <i class="fi fi-rs-marker"></i>
                        {{row.Location}}
                    </div>
                </td>
                <td class="text-nowrap hidden-md-down">
                    <div>{{row.Date | appDate}}</div>
                    <div class="text-sub">{{row.TimeFrom | appTime}} - {{row.TimeTo | appTime}}</div>
                </td>
                <td class="hidden-md-down">{{row.Location}}</td>
                <td class="hidden-sm-down">
                    <app-lesson-observation-status [value]="row.Status"></app-lesson-observation-status>
                </td>
                <td>
                    <div class="table-actions">
                        <button *ngIf="checkDelete(row)"
                                type="button"
                                (click)="delete(row)"
                                class="btn btn-outline-primary btn-icon"
                                [ngbTooltip]="'delete' | translate">
                            <i class="fi fi-rs-trash"></i>
                        </button>

                        <button type="button"
                                class="btn btn-outline btn-icon"
                                [routerLink]="['/lesson-observations', row.Id] | localize"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
